import React from 'react'

import Input, { InputProps } from 'common/components/base/forms/Input'

import BarcodeIcon from 'common/assets/images/barcode-icon.svg?react'

export type ScanInputProps = Omit<InputProps, 'classes'>

const ScanInput: React.FC<ScanInputProps> = (props) => {
  return <Input autoFocus startAdornment={<BarcodeIcon />} {...props} />
}
export default React.memo(ScanInput)
